// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2kNid","noInteraction":"EventWrapper_noInteraction__314X2"};